$(document).on('turbolinks:load', function() {
  // Hide Order List on Section Home After Clicking Tabs
  $(document).on('click', '.nav-link', function(e){
    $('#home').hide();
  });

});
